import { useQuery } from '@tanstack/react-query';

import { userStore } from '~/stores';

const FIVE_MINUTES = 5 * 60 * 1000;

export const useDeliveryZones = (enabled = true) => {
  return useQuery({
    queryKey: ['deliveryZones', enabled],
    queryFn: userStore.getDeliveryZones,
    staleTime: FIVE_MINUTES,
    enabled,
  });
};
